import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { authSlice } from './slices/authSlice';
import { apiSlice } from './api/apiSlice';
import { betSlice } from './slices/betSlice';
import { uiSlice } from './slices/uiSlice';

const rootReducer = combineReducers({
  auth: authSlice.reducer,
  api: apiSlice.reducer,
  bet: betSlice.reducer,
  ui: uiSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

/** Builds a store with the app's reducers and middleware; tests create a fresh one each. */
export const createStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        },
      }).concat(apiSlice.middleware),
    devTools: import.meta.env.DEV,
  });

export const store = createStore();

setupListeners(store.dispatch);

export type AppStore = ReturnType<typeof createStore>;
export type AppDispatch = AppStore['dispatch'];
